export default __webpack_public_path__ + "assets/images/35be8b4fdfba8557cd1ad92753402497.png";